<template>
  <header class="header-container">
    <!-- 左侧区域 -->
    <div class="header-left">
      <div class="logo-area">
        <img
          src="@/assets/images/mainlogo.png"
          alt="系统Logo"
          class="logo"
        />
        <!-- PC端：折叠/展开按钮；手机端：打开/关闭菜单按钮 -->
        <button
          class="menu-toggle"
          :title="isMobile ? (mobileMenuOpen ? '关闭菜单' : '打开菜单') : (isCollapse ? '展开菜单' : '收起菜单')"
          @click="handleMenuToggle"
        >
          <el-icon>
            <Fold v-if="!isMobile && !isCollapse" />
            <Expand v-else-if="!isMobile && isCollapse" />
            <Fold v-else-if="isMobile && mobileMenuOpen" />
            <Expand v-else-if="isMobile && !mobileMenuOpen" />
          </el-icon>
        </button>
      </div>
      <!-- 面包屑导航（手机端隐藏） -->
      <nav class="breadcrumb-nav" :class="{ 'mobile-hidden': isMobile }">
        <el-breadcrumb separator="/">
          <!-- 首页项 -->
          <el-breadcrumb-item>
            <el-icon><LocationInformation /></el-icon>
            <span>首页</span>
          </el-breadcrumb-item>
          <!-- 其他面包屑项 - 过滤掉首页相关的项 -->
          <el-breadcrumb-item
            v-for="(item, index) in filteredBreadcrumbList"
            :key="item.key || item.title || index"
          >
            {{ item.title }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </nav>
    </div>
    <!-- 右侧区域 -->
    <div class="header-right">
      <UserInfo />
    </div>
  </header>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { Fold, Expand, HomeFilled } from '@element-plus/icons-vue'
import { useMenuStore } from '@/stores'
import UserInfo from "../UserInfo/index.vue"
const emit = defineEmits(['toggle-menu', 'toggle-mobile-menu'])
const menuStore = useMenuStore()
// 手机端相关状态
const isMobile = ref(false)
const mobileMenuOpen = ref(false)
// 过滤后的面包屑列表 - 排除首页相关的项
const filteredBreadcrumbList = computed(() => {
  const breadcrumb = menuStore.breadcrumb || []
  return breadcrumb.filter(item => {
    if (item.title === '首页') return false
    if (item.path === '/layout/dashboard') return false
    if (item.isHome === true) return false
    if (item.icon === 'Dashboard') return false
    return true
  })
})

// 监听侧边栏折叠状态变化（同步图标）
const isCollapse = computed(() => menuStore.isCollapsed)
// 检测是否为手机端
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768
}
// 处理菜单按钮点击
const handleMenuToggle = () => {
  if (isMobile.value) {
    mobileMenuOpen.value = !mobileMenuOpen.value
    emit('toggle-mobile-menu')
    window.dispatchEvent(new CustomEvent('mobile-menu-state', {
      detail: { open: mobileMenuOpen.value }
    }))
  } else {
    emit('toggle-menu')
  }
}
// 监听手机菜单状态变化
const handleMobileMenuStateChange = (event) => {
  if (event.detail?.open !== undefined) {
    mobileMenuOpen.value = event.detail.open
  }
}
onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
  window.addEventListener('mobile-menu-state', handleMobileMenuStateChange)
})
onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
  window.removeEventListener('mobile-menu-state', handleMobileMenuStateChange)
})
</script>
<style scoped lang="scss">
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 54px;
  padding: 0 20px;
  color: #fff;
  .header-left {
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 1;
    .logo-area {
      display: flex;
      align-items: center;
      gap: 12px;
      .logo {
        height: 50px;
        width: auto;
        transition: transform 0.3s ease;
        &:hover {
          transform: scale(1.05);
        }
      }
      .menu-toggle {
        display: flex;
        align-items: center;
        justify-content: center;
        background: none;
        border: none;
        color: #fff;
        cursor: pointer;
        padding: 8px;
        border-radius: 4px;
        transition: all 0.2s;
        &:hover {
          background: rgba(255, 255, 255, 0.1);
        }
        .el-icon {
          font-size: 20px;
        }
      }
    }
    .breadcrumb-nav {
      flex: 1;
      :deep(.el-breadcrumb) {
        color: #fff;
        .el-breadcrumb__inner {
          font-weight: normal;
          color: rgba(255, 255, 255, 0.9);
          &:hover {
            color: #fff;
          }
        }
        .el-breadcrumb__item:first-child {
          .el-icon{
            font-size: 16px;
            justify-content: center;
          }
        }
        .el-breadcrumb__separator {
          font-weight: normal;
          color: rgba(255, 255, 255, 0.7);
        }
        .el-breadcrumb__item:last-child {
          .el-breadcrumb__inner {
            color: #fff;
            font-weight: normal;
          }
          .el-breadcrumb__separator {
            display: none !important;
          }
        }
      }
    }
  }
  .header-right {
    flex-shrink: 0;
    margin-right: 80px;
  }
}

// 响应式设计
@media (max-width: 768px) {
  .header-container {
    padding: 0 12px;
    .header-left {
      gap: 12px;
      .logo-area {
        .logo {
          height: 30px;
        }
        .menu-toggle {
          padding: 6px;
          .el-icon {
            font-size: 18px;
          }
        }
      }
      .breadcrumb-nav {
        &.mobile-hidden {
          display: none;
        }
      }
    }
    .header-right {
      margin-right: 0;
    }
  }
}
</style>
